var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTime(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 0C17.9487 0 0 17.9487 0 40C0 62.0513 17.9487 80 40 80C62.0513 80 80 62.0513 80 40C80 17.9487 62.0513 0 40 0ZM46.2564 43.5385V43.4872C45 45.6667 42.6923 47.1795 40 47.1795C36.0256 47.1795 32.8205 43.9487 32.8205 40C32.8205 37.4872 34.1026 35.3077 36.0256 34.0256L59.6923 20.4359L46.282 43.5128L46.2564 43.5385Z",
    fill: "#F5F7FE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTime);
export default __webpack_public_path__ + "static/media/Time.a8dc636ec054cd67754b39f72589cec1.svg";
export { ForwardRef as ReactComponent };